import { render } from "./CollectionDetailedSearchPrange.vue?vue&type=template&id=adc1995a&scoped=true&ts=true"
import script from "./CollectionDetailedSearchPrange.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchPrange.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchPrange.vue?vue&type=style&index=0&id=adc1995a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adc1995a"]])

export default __exports__